import {
    ACTIVITY_QR_CODE,
    ACTIVITY_TYPE_PLACEHOLDER, ATTENDANCE, BUTTON, COPIED_TEXT, LINK,
    NO_QR_CODE_OR_POLL_CODE_TO_SHARE, PARTICIPANTS_TEXT, POLL_SHARE_MODE, POLL_TEXT,
    POLL_TYPE, SCHEDULE_TO_TEXT, SHARE_POLL_BUTTON_DISABLED_TOOLTIP_TEXT,
    SHARE_TEXT, SYNC_LMS_OPTIONS,
    UNIQUECODE_TEXT
} from "../../utils/constants";
import classes from "./ReleaseActivityPage.module.css";
import React, {useEffect, useId, useState} from "react";
import {ReactComponent as COPY_LINK_ICON} from "./images/copy_link_icon.svg";
import {ReactComponent as SHARED_ICON} from "../../images/share_black.svg";
import {ReactComponent as QR_ICON} from "./images/QR_code_icon.svg";
import {ReactComponent as COPY_ICON} from "../../images/copy_gray.svg";

import {deCapitalizeWord, notifySuccess} from "../../utils/helpers";
import YuJaButton from "../../components/standardization/YuJaButton";
import {QRCodeCanvas}  from "qrcode.react";
import {useParams} from "react-router-dom";
import CopyToClipboard from "react-copy-to-clipboard";
import {CLIPBOARD_COPY_SUCCESS} from "../../utils/toast-message-constants";
import ImageViewer from "../JoinQuizPage/ImageViewer";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {Button} from "@base-ui/react/button";
import { Popover } from '@base-ui/react/popover';
import {Separator} from "@base-ui/react/separator";


export default function ViewActivityShareButton({pollData}) {
    const { pollKey, pollCode } = useParams();

    const uniqueId = useId();


    const {poll = {}, questions = []} = pollData;

    const { pollType} = poll;

    const {getRedirectUrl} = useSynLMSConfiguration();

    const [cardOpen, setCardOpen] = useState(false);
    const [QRCodeImageURL, setQRCodeImageURL] = useState("");
    const [copied, setCopied] = useState(false);


    const btnStyle = {width: 200, height: 35, display: "flex", alignItems: "center", justifyContent: "center"};




    const downloadQR = () => {
        let downloadLink = document.createElement("a");
        downloadLink.href = QRCodeImageURL;
        downloadLink.download = `${pollCode}.png`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };


    useEffect(() => {
        if (!getRedirectUrl(poll)) {
            return;
        }


        const observer = new MutationObserver((mutations, obs) => {
            // Check if selector now returns an element
            const canvas = document.querySelector(`#QR${pollCode}`);
            if (!canvas) {
                return;
            }
            const backgroundColor = "#FFFFFF";

            const qrCodeWidth = canvas.width;
            const qrCodeHeight = canvas.height;

            const padding = 10;

            const newWidth = qrCodeWidth + 2 * padding;
            const newHeight = qrCodeHeight + 2 * padding;

            const newCanvas = document.createElement("canvas");
            newCanvas.width = newWidth;
            newCanvas.height = newHeight;
            const newContext = newCanvas.getContext("2d");

            newContext.fillStyle = backgroundColor;
            newContext.fillRect(0, 0, newWidth, newHeight);

            newContext.drawImage(canvas, padding, padding, qrCodeWidth, qrCodeHeight);

            const pngUrl = newCanvas.toDataURL("image/png");

            setQRCodeImageURL(pngUrl);
            obs.disconnect(); //Stop watch once found


        });

        observer.observe(document, {childList: true, subtree: true});



    }, []);

    if (!getRedirectUrl(poll) && poll.syncLmsOption === SYNC_LMS_OPTIONS.LMS_API_SYNC) {
        return (
            <YuJaTooltip
                text={SHARE_POLL_BUTTON_DISABLED_TOOLTIP_TEXT.replaceAll(
                    ACTIVITY_TYPE_PLACEHOLDER,
                    pollType === POLL_TYPE.ATTENDANCE
                        ? deCapitalizeWord(ATTENDANCE)
                        : deCapitalizeWord(POLL_TEXT)
                )}
                placement={"bottom"}
            >
                <Button
                    className={`${classes.smallBtn} ${classes.disabled}`}
                    disabled={true}
                    style={{width: 85}}
                >
                    <SHARED_ICON style={{marginRight: 7}}/>
                    {SHARE_TEXT}
                </Button>
            </YuJaTooltip>
        );
    }


    return (
        <Popover.Root
            open={!!cardOpen}
            onOpenChange={(open) => setCardOpen(open)}
        >
            <Popover.Trigger
                delay={0}
                aria-label={SHARE_TEXT + " " +
                    (pollType === POLL_TYPE.ATTENDANCE ? deCapitalizeWord(ATTENDANCE)
                    : deCapitalizeWord(POLL_TEXT) )
                    + " " + SCHEDULE_TO_TEXT + " " + PARTICIPANTS_TEXT
                }
                className={`${classes.smallBtn} ${cardOpen ? classes.opened : ""}`}
                style={{width: 85}}
            >
                <SHARED_ICON style={{marginRight: 7}}/>
                {SHARE_TEXT}
            </Popover.Trigger>
            <Popover.Portal keepMounted={true}>
                <Popover.Positioner
                    sideOffset={5}
                    align={"start"}
                >

                    <Popover.Popup
                        aria-modal="false"
                        initialFocus={false}
                        className={classes.activityInfoCard}
                        style={{width: 350, gap: 15, color: "#000"}}
                    >

                        {!!getRedirectUrl(poll) &&
                            <>
                                {(!poll.pollShareMode || poll.pollShareMode === POLL_SHARE_MODE.UNKNOWN) &&
                                    <span className={classes.description}>
                                        {pollType === POLL_TYPE.ATTENDANCE
                                            ? "Remember to release your attendance after it is shared."
                                            : "Remember to release your poll after it is shared."
                                        }
                                    </span>
                                }

                                <div className={classes.row}>
                                    <COPY_LINK_ICON style={{marginRight: 7}}/>
                                    <span>{pollType === POLL_TYPE.ATTENDANCE ? "Attendance Link" : "Poll Link"}</span>
                                    <div style={{flex: 1}}/>
                                    <CopyToClipboard
                                        text={getRedirectUrl(poll)}
                                        onCopy={() => notifySuccess(CLIPBOARD_COPY_SUCCESS.replace(UNIQUECODE_TEXT, pollType === POLL_TYPE.ATTENDANCE ? "Attendance Link" : "Poll Link"))}
                                    >
                                        <YuJaButton style={btnStyle}>
                                            {pollType === POLL_TYPE.ATTENDANCE ? "Copy Attendance Link" : "Copy Poll Link"}
                                        </YuJaButton>

                                    </CopyToClipboard>


                                </div>
                                <Separator style={{height: 1, background: "#D1D1D1", width: "100%", margin: "10px 0"}}/>

                                <div className={classes.row}>
                                    <div className={classes.column} style={{ gap: 10}}>
                                        <div className={classes.row}>
                                            <QR_ICON style={{marginRight: 7}}/>
                                            <span>{"QR Code"}</span>
                                        </div>

                                        <div
                                            className={classes.QRContainer}
                                            style={{alignSelf: "center"}}
                                        >
                                            <ImageViewer
                                                size={70}
                                                alt={ACTIVITY_QR_CODE}
                                                imageURL={QRCodeImageURL}
                                                aria-labelledby={uniqueId}
                                            />


                                            <QRCodeCanvas
                                                id={`QR${pollCode}`}
                                                size={512}
                                                style={{display: "none",}}
                                                value={getRedirectUrl(poll)}
                                            />
                                        </div>

                                        <span id={uniqueId} style={{color: "#717171"}}>{"Click to Enlarge"}</span>
                                    </div>
                                    <div style={{flex: 1}}/>

                                    <a tabIndex={0} className={classes.downloadQRCodeLink} onClick={downloadQR}>
                                        {"Download QR Code"}
                                    </a>
                                </div>
                            </>
                        }
                        {!getRedirectUrl(poll) && poll.syncLmsOption === SYNC_LMS_OPTIONS.EMBEDDED &&
                            <>
                                <span className={classes.description}>
                                    {NO_QR_CODE_OR_POLL_CODE_TO_SHARE
                                        .replaceAll(
                                            ACTIVITY_TYPE_PLACEHOLDER,
                                            pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE : POLL_TEXT
                                        )
                                        // + (` from ${poll.lmsHomeUrl}`)
                                    }
                                </span>

                                <YuJaTooltip
                                    text={!copied ? "" : COPIED_TEXT}
                                    placement={"bottom"}
                                    tooltipStyle={{maxWidth: 240}}
                                    disabled={!copied}
                                >
                                    <CopyToClipboard
                                        text={!!poll.lmsCourseUrl ? poll.lmsCourseUrl : poll.lmsHomeUrl}
                                        onMouseLeave={() => setCopied(false)}
                                        onCopy={() => setCopied(true)}
                                    >
                                <span className={classes.row} style={{lineHeight: 1.5, cursor: "pointer"}}>
                                    <span
                                        style={{color: "#434343", fontSize: 15, fontWeight: "600", marginRight: 5}}>
                                        {LINK.charAt(0).toUpperCase() + LINK.slice(1)}:
                                    </span>
                                    <span className={classes.link} style={{
                                        flexShrink: 1,
                                        minWidth: 0,
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis"
                                    }}>
                                        {!!poll.lmsCourseUrl ? poll.lmsCourseUrl : poll.lmsHomeUrl}
                                    </span>
                                    <COPY_ICON style={{marginLeft: 5, flexShrink: 0}}/>
                                </span>
                                    </CopyToClipboard>
                                </YuJaTooltip>
                            </>
                        }

                    </Popover.Popup>

                    {/*{!getRedirectUrl(poll) && poll.syncLmsOption === SYNC_LMS_OPTIONS.EMBEDDED &&*/}
                    {/*    <Popover.Popup*/}
                    {/*        className={classes.activityInfoCard}*/}
                    {/*        style={{width: 350, gap: 15, color: "#000"}}*/}
                    {/*    >*/}
                    {/*        <span className={classes.description}>*/}
                    {/*            {NO_QR_CODE_OR_POLL_CODE_TO_SHARE*/}
                    {/*                .replaceAll(*/}
                    {/*                    ACTIVITY_TYPE_PLACEHOLDER,*/}
                    {/*                    pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE : POLL_TEXT*/}
                    {/*                )*/}
                    {/*                // + (` from ${poll.lmsHomeUrl}`)*/}
                    {/*            }*/}
                    {/*        </span>*/}

                    {/*        <YuJaTooltip*/}
                    {/*            text={!copied ? "" : COPIED_TEXT}*/}
                    {/*            placement={"bottom"}*/}
                    {/*            tooltipStyle={{maxWidth: 240}}*/}
                    {/*            disabled={!copied}*/}
                    {/*        >*/}
                    {/*            <CopyToClipboard*/}
                    {/*                text={!!poll.lmsCourseUrl ? poll.lmsCourseUrl : poll.lmsHomeUrl}*/}
                    {/*                onMouseLeave={() => setCopied(false)}*/}
                    {/*                onCopy={() => setCopied(true)}*/}
                    {/*            >*/}
                    {/*                <span className={classes.row} style={{lineHeight: 1.5, cursor: "pointer"}}>*/}
                    {/*                    <span*/}
                    {/*                        style={{color: "#434343", fontSize: 15, fontWeight: "600", marginRight: 5}}>*/}
                    {/*                        {LINK.charAt(0).toUpperCase() + LINK.slice(1)}:*/}
                    {/*                    </span>*/}
                    {/*                    <span className={classes.link} style={{*/}
                    {/*                        flexShrink: 1,*/}
                    {/*                        minWidth: 0, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}>*/}
                    {/*                        {!!poll.lmsCourseUrl ? poll.lmsCourseUrl : poll.lmsHomeUrl}*/}
                    {/*                    </span>*/}
                    {/*                    <COPY_ICON style={{marginLeft: 5, flexShrink: 0}}/>*/}
                    {/*                </span>*/}
                    {/*            </CopyToClipboard>*/}
                    {/*        </YuJaTooltip>*/}
                    {/*    </Popover.Popup>*/}
                    {/*}*/}
                </Popover.Positioner>
            </Popover.Portal>


        </Popover.Root>
    );
}